// extracted by mini-css-extract-plugin
export default {"modal-content":"Modal_modal-content__sxCCs","close":"Modal_close__Qng1R","right-close":"Modal_right-close__SMFgy","rounded-close-card":"Modal_rounded-close-card__AdRC4"};